var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("List Customer")]),
      _c("searchComponent", { attrs: { data: _vm.obj, query: _vm.query } }),
      _c("div", {
        staticClass: "columnd clearfix",
        staticStyle: { background: "red" }
      }),
      _vm._m(0),
      _c("table", { staticClass: "table" }, [
        _vm._m(1),
        _c(
          "tbody",
          _vm._l(_vm.listUser, function(item, index) {
            return _c("tr", { key: item.userID }, [
              _c("td", [_vm._v(_vm._s(index))]),
              _c("td", [_vm._v(_vm._s(item.id))]),
              _c("td", [_vm._v(_vm._s(item.firstName))]),
              _c("td", [_vm._v(_vm._s(item.role))]),
              _c("td", [_vm._v(_vm._s(item.phone))]),
              _c("td", [_vm._v(_vm._s(item.email))])
            ])
          })
        )
      ]),
      _c("pagination")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [_c("br"), _c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("No.")]),
        _c("th", [_vm._v("CustName")]),
        _c("th", [_vm._v("TaxID")]),
        _c("th", [_vm._v("Business Type")]),
        _c("th", [_vm._v("Phone")]),
        _c("th", [_vm._v("Contact Name")]),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5939df8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5939df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/customer-list.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a5939df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/customer-list.vue
// module chunks = 28